import { AxiosError } from "axios";
import { isApiResponseError } from "@web-monorepo/fetchers";

const COPPA_MARKETPLACE_API_ERROR_STR = "user COPPA consent is needed.";
const COPPA_ERROR_CODE = "ERR_COPPA_CONSENT_REQUIRED";

interface CoppaErrorResponse {
  error?: {
    code?: string;
    detail?: string | { error?: string };
  };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function isCoppaErrorResponse(value: unknown): value is CoppaErrorResponse {
  if (!isRecord(value) || !isRecord(value.error)) {
    return false;
  }

  const { code, detail } = value.error;
  if (code !== undefined && typeof code !== "string") {
    return false;
  }
  if (detail !== undefined && typeof detail !== "string" && !isRecord(detail)) {
    return false;
  }
  return !isRecord(detail) || detail.error === undefined || typeof detail.error === "string";
}

export function checkIsCoppaError(error: unknown): boolean {
  const responseData =
    error instanceof AxiosError ? error.response?.data : isApiResponseError(error) ? error.response.body : undefined;
  const data = isCoppaErrorResponse(responseData) ? responseData : undefined;
  const detail = data?.error?.detail;
  const marketplaceApiErrorStr = isRecord(detail) ? detail.error : undefined;
  const coppaErrorCode = data?.error?.code;
  return marketplaceApiErrorStr === COPPA_MARKETPLACE_API_ERROR_STR || coppaErrorCode === COPPA_ERROR_CODE;
}
